import Swiper from 'swiper';
import { Grid, Pagination } from 'swiper/modules';

let studioSwipers = new Map(); // Store multiple swiper instances

function initOrDestroyStudioSwiper() {
  const containers = document.querySelectorAll('.studio-slider .swiper');
  const isMobile = window.innerWidth <= 767;

  containers.forEach(container => {
    const containerId = container.id || container.closest('.studio-slider').id || `studio-slider-${Array.from(containers).indexOf(container)}`;
    
    // Get limits from the first studio card data attributes in this container
    const firstStudioCard = container.querySelector('.game-studios-card[data-limit-desktop]');
    const limitDesktop = firstStudioCard ? parseInt(firstStudioCard.dataset.limitDesktop, 10) : 7;
    const limitMobile = firstStudioCard ? parseInt(firstStudioCard.dataset.limitMobile, 10) : 50;
    
    if (isMobile && !studioSwipers.has(containerId)) {
      // Create pagination element if it doesn't exist
      if (!container.querySelector('.swiper-pagination')) {
        const pag = document.createElement('div');
        pag.className = 'swiper-pagination';
        container.appendChild(pag);
      }

      // Calculate optimal configuration based on total items
      const totalSlides = container.querySelectorAll('.swiper-slide').length;
      const itemsPerView = 8; // Target 8 items per view
      
      // Calculate how many complete pages of 8 items we can have
      const completePages = Math.floor(totalSlides / itemsPerView);
      const remainingItems = totalSlides % itemsPerView;
      
      let swiperConfig = {
        modules: [Grid, Pagination],
        slidesPerView: 2, // 2 columns
        slidesPerGroup: 2, // Move 2 slides at a time (showing 8 items: 2 slides × 4 rows)
        grid: {
          rows: 4,
          fill: 'row',
        },
        spaceBetween: 16,
        centeredSlides: false,
        normalizeSlideIndex: false, // Changed to false for better control
        roundLengths: true,
        watchSlidesProgress: true,
        allowTouchMove: true,
        resistanceRatio: 0.5,
        pagination: {
          el: container.querySelector('.swiper-pagination'),
          clickable: true,
          dynamicBullets: true,
        },
      };
      
      // Ensure we don't over-slide on the last page
      if (totalSlides > itemsPerView) {
        // Calculate the maximum slide index we should allow
        const maxSlideIndex = Math.ceil(totalSlides / 4) - 2; // Total slide groups minus slides per view
        swiperConfig.slidesPerGroup = 2;
        swiperConfig.watchOverflow = true;
      }

      const swiper = new Swiper(container, swiperConfig);

      // Add custom event handlers
      swiper.on('slideChange', function() {
        // Force recalculation of slide positions
        this.updateSlides();
        this.updateProgress();
      });
      
      swiper.on('resize', function() {
        // Recalculate grid and slides on orientation change
        this.updateSlides();
        this.updateProgress();
      });
      
      studioSwipers.set(containerId, swiper);
    }
    else if (!isMobile && studioSwipers.has(containerId)) {
      // Destroy swiper on desktop
      const swiper = studioSwipers.get(containerId);
      swiper.destroy(true, true);
      studioSwipers.delete(containerId);
      // Remove pagination
      const pag = container.querySelector('.swiper-pagination');
      if (pag) pag.remove();
    }

    // Nothing to reveal or re-hide — same change as the games slider (game-slider-init.js).
    // Studios past the desktop limit ship visible and are hidden on desktop by
    // `.studio-slider .swiper-slide.mobile-only-studio` in the _base.scss up(md) branch.
    // Clearing inline display:none after the constructor was what left swiper measuring the
    // desktop set only; the class is no longer removed either, so resizing back to desktop
    // can still hide them.
  });
}

// Initialize on DOM content loaded
function initStudiosSlider() {
  initOrDestroyStudioSwiper();
}

// Debounced resize handler
let resizeTimeout;
window.addEventListener('resize', () => {
  clearTimeout(resizeTimeout);
  resizeTimeout = setTimeout(initOrDestroyStudioSwiper, 200);
});

// Run immediately if DOM is already loaded to prevent flicker.
// NB: the unconditional `DOMContentLoaded` listener that used to sit above the resize handler
// is gone — it made initStudiosSlider run twice on DCL. Same duplicate existed in
// game-slider-init.js and was removed with it; this branch covers both cases on its own.
if (document.readyState === 'loading') {
  // DOM hasn't finished loading yet
  window.addEventListener('DOMContentLoaded', initStudiosSlider);
} else {
  // DOM has already loaded
  initStudiosSlider();
}

// Handle orientation change on mobile devices
window.addEventListener('orientationchange', () => {
  setTimeout(initOrDestroyStudioSwiper, 300);
});
